import apiinfo from "../../../../utils/base-uri.json";
import { useForm } from "react-hook-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, Button, TextField } from '@mui/material'
import React, { useState, useEffect } from 'react'
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import useFetch from "../../../../utils/useFetch";
import { getGlobalClientId, getToken ,getOrgType} from "../../../../utils/Token";
import BaseURL from "../../../../utils/base-uri.json";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function ReportFeesPaid({ close, name }) {

  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(getToken())

  useEffect(() => {
    axios
    .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
    getGlobalClientId())
      .then((res) => {
        if (res.data.responseCode === 100) {
          setClient(res.data.data);
          if(getOrgType()=="Client"){
            setSelectValue1(res?.data?.data[0]?.value)}
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const { register } = useForm();
  const [selectValue1, setSelectValue1] = useState("");
  const [getTemplate, SetTemplate] = React.useState([]);
  const changeClients = (e) => {
    setSelectValue1(e);
  };
  const { data: res } = useFetch(
    "Client/GetFeeTemplates?clientId=" + selectValue1
  );
  useEffect(() => {
    if (res?.data) {
      SetTemplate(res?.data)

    }
  }, [res]);

  const data = getTemplate[0]
  const [selectedValue, setSelectedValue] = useState(data);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  const [showAlert, setShowAlert] = useState(false);
  const [showAlert1, setShowAlert1] = useState(false);
  const [fromDateValue, setFromDateValue] = useState(null);
  const [toDateValue, setToDateValue] = useState(null);

  const getMonthDifference = (fromDate, toDate) => {
    const diffInMonths = Math.floor(
      (toDate - fromDate) / (1000 * 60 * 60 * 24 * 30.44)
    );
    return diffInMonths;
  };

  const handleFromDateChange = (e) => {
    const newFromDate = e;
    setFromDateValue(newFromDate);

    // Check if From date is greater than To date
    if (newFromDate > toDateValue) {
      setShowAlert(true);
    } else {
      setShowAlert(false);

      // Check if the date range is more than six months
      const fromDate = new Date(newFromDate);
      const toDate = new Date(toDateValue);
      const monthDifference = getMonthDifference(fromDate, toDate);

      if (monthDifference > 5) {
        setShowAlert1(true);
      } else {
        setShowAlert1(false);
      }
    }
  };

  const handleToDateChange = (e) => {
    const newToDate = e;
    setToDateValue(newToDate);

    // Check if From date is greater than To date
    if (fromDateValue > newToDate) {
      setShowAlert(true);
    } else {
      setShowAlert(false);

      // Check if the date range is more than six months
      const fromDate = new Date(fromDateValue);
      const toDate = new Date(newToDate);
      const monthDifference = getMonthDifference(fromDate, toDate);

      if (monthDifference > 5) {
        setShowAlert1(true);
      } else {
        setShowAlert1(false);
      }
    }
  };

  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
  };
  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
        {showAlert && (
          <div className="text-center" style={{ color: "red" }}>
            From date should be less than To date
          </div>
        )}
          {showAlert1 && (
          <div  className="text-center" style={{ color: "red" }}>
            Difference Between From date and To date should not exceed 6 Months
          </div>
        )}
        <form
          action={
            BaseURL?.baseReportUrl + "FeesPaid.aspx"
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: "25px" }}>

            <FormControl sx={{ m: 1, width: 320 }}>
              <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px", }} >  From </span>

              {/* <TextField type="date" sx={{ width: "320px" }} name="fromDate" size="small" value={fromDateValue || ""} onChange={handleFromDateChange} onKeyDown={handleDateKeyDown} /> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={fromDateValue}
                  onChange={handleFromDateChange}
                  name="fromDate"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      size="small"
                      name="fromDate"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px", }} >To</span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={toDateValue}
                  name="toDate"
                  onChange={handleToDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      name="toDate"
                      size="small"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              {/* <TextField type="date" sx={{ width: "320px" }} name="toDate" size="small" value={toDateValue || ""} onChange={handleToDateChange} onKeyDown={handleDateKeyDown} /> */}
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                Client
              </span>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                {...register("client")}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}
                size="small"
                name="ClientId"
                onChange={(e) => changeClients(e.target.value)}
                input={
                  <OutlinedInput label="Select Client" value={selectValue1} />
                }
                MenuProps={MenuProps}
              >
                {client?.map((item, index) => (
                  <MenuItem key={index} title={item?.text} value={item?.value}>
                    {item?.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",

                  marginBottom: "5px",
                }}
              >
                 Template
              </span>
              <Select sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
              }}
                name="TemplateId"
                displayEmpty
                MenuProps={MenuProps}
                size="small" value={selectedValue} onChange={handleChange}>
       
                {getTemplate?.map((option) => (
                  <MenuItem key={option?.key} value={option?.key}>
                    {option?.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <DialogActions>
       
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                type="submit"
                className="login-button-request"
                onClick={close}
                disabled={
                  showAlert ||
                  showAlert1||
                  fromDateValue === "" ||
                  toDateValue === "" ||
                selectValue1 === ""
                }
              >
                Create Report
              </Button>
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token} />
        </form>

        <br />
      </DialogContent>

    </>
  )
}

